import React, { useEffect, useRef } from 'react';
export const Portfolio = () => {
  const companies = [{
    name: 'Databricks',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754428735/Databricks_White_Large_cmbvsn.png',
    height: 61
  }, {
    name: 'Groq (Acq by Nvidia)',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1771636961/Groq_White_Large_rfnihk.png',
    height: 61,
    showExit: true
  }, {
    name: 'Skypilot',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754429401/Skypilot_White_Large_dimtjc.png',
    height: 61
  }, {
    name: 'Goodnotes',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754432034/Goodnotes_White_Logo_ov9hvp.png',
    height: 61
  }, {
    name: 'Vectara',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754936326/Vectara_White_Large_st1oba.png',
    height: 61
  }, {
    name: 'PLAY.AI',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761250603/Play_White_ezvk1c.png',
    height: 61,
    showExit: true
  }, {
    name: 'Opaque',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754428735/opaque_white_large_nos7uc.png',
    height: 61
  }];
  // Triple the companies array for seamless looping
  const allCompanies = [...companies, ...companies, ...companies];
  const carouselRef = useRef(null);
  useEffect(() => {
    // Preload all images
    companies.forEach(company => {
      const img = new Image();
      img.src = company.logo;
    });
  }, []);
  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;
    const handleAnimationEnd = () => {
      carousel.style.animation = 'none';
      carousel.offsetHeight;
      carousel.style.animation = null;
    };
    carousel.addEventListener('animationend', handleAnimationEnd);
    return () => {
      carousel.removeEventListener('animationend', handleAnimationEnd);
    };
  }, []);
  return <section className="w-full pt-16 pb-48 px-6 md:px-12 bg-white transition-colors" data-id="element-103">
      <div className="max-w-7xl mx-auto" data-id="element-104">
        <div className="relative w-full overflow-hidden py-4 -my-4" data-id="element-105">
          <style jsx data-id="element-106">{`
            @keyframes scroll {
              0% {
                transform: translateX(0);
              }
              100% {
                transform: translateX(calc(-100% / 3));
              }
            }
            .carousel {
              display: flex;
              width: fit-content;
              animation: scroll 30s linear infinite;
            }
          `}</style>
          <div ref={carouselRef} className="carousel" data-id="element-107">
            {allCompanies.map((company, index) => <div key={index} className="flex-shrink-0 px-4 md:px-8 w-[200px] md:w-[360px] h-[140px] flex items-center justify-center" data-id="element-108">
                <div className="relative w-full h-full flex items-center justify-center" data-id="element-109">
                  {company.showExit && <div className="absolute -top-2 right-0 px-1.5 py-0.5 border border-gray-400 rounded bg-white z-10" data-id="element-110">
                      <span className="text-gray-600 font-semibold text-[8px] tracking-wide" data-id="element-111">
                        EXIT
                      </span>
                    </div>}
                  <img src={company.logo} alt={`${company.name} logo`} loading="eager" className="max-w-full max-h-[72px] object-contain opacity-90 hover:opacity-100 transition-opacity" data-id="element-112" />
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};